import { NoData, Pending, useErrorState } from '@finbeat/react-toolkit';
import { AxiosError } from 'axios';
import { downloadDocument, getDocuments } from 'axios/orderApi';
import FileSaver from 'file-saver';
import useApi from 'hooks/useApi';
import _ from 'lodash';
import { AxiosErrorResponse } from 'models/api/axiosErrorResponse';
import DataGridProp from 'models/dataGridProp';
import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Table } from 'reactstrap';
import '../OrderInfo.scss';
// import { useNotifyContext } from 'providers/NotifyProvider';
// import { useDocumentLock } from 'hooks/useDocumentLock';
// import useAuth from 'hooks/useAuth';

type File = {
    fileName: string;
    id: number;
    createDate: Date;
};

type DocumentWithFiles = DataGridProp & {
    name: string;
    files: File[];
};

const DocumentsTab = ({ id, isOpen }: { id: number; isOpen: boolean }) => {
    const api = useApi();
    const { handleRequestError } = useErrorState();
    const [documents, setDocuments] = useState<DocumentWithFiles[] | undefined>();
    const [document, setDocument] = useState<File | undefined>(undefined);
    const [wasOpened, setWasOpened] = useState(false);
    const [documentsOther, setDocumentsOther] = useState<DocumentWithFiles[] | undefined>();
    const courtNames = ['calculation_rus', 'log_file_rus', 'ariza_uzb'];
    // const [documentsCourt, setDocumentsCourt] = useState<DocumentWithFiles[] | undefined>();
    // const { addToast } = useToastContext();
    // const { isLocked, lock } = useDocumentLock(id);
    // const today = new Date().toISOString().split('T')[0];
    // const { hasRole } = useAuth();
    // const { t } = useTranslation();

    useEffect(() => {
        !wasOpened && setWasOpened(isOpen);
    }, [isOpen]);

    // const { addSubscription, removeSubscription } = useNotifyContext();

    // useEffect(() => {
    //     addSubscription({
    //         key: 'onDocumentGenerationStop',
    //         type: 'DocumentGenerationStop',
    //         callback: (params) => {
    //             if (JSON.parse(params).OrderId === id.toString()) {
    //                 documentsQuery.refetch().catch((err) => {
    //                     console.error('Error refresh docs', err);
    //                 });
    //             }
    //         },
    //     });
    //
    //     return () => {
    //         removeSubscription('onDocumentGenerationStop');
    //     };
    // }, []);

    const documentsQuery = useQuery(['documents', id], () => getDocuments(api, id), {
        onSuccess: (data) => {
            const docs = _.chain(data)
                .groupBy('name')
                .map(
                    (value, key) =>
                        ({
                            id: key,
                            name: key,
                            files: value.map((file) => ({
                                id: file.id,
                                fileName: file.fileName,
                                createDate: file.createDate,
                            })),
                        }) as DocumentWithFiles
                )
                .value();
            setDocuments(docs);
            // setDocumentsCourt(docs.filter((doc) => courtNames.includes(doc.name)));
            setDocumentsOther(docs.filter((doc) => !courtNames.includes(doc.name)));
        },
        enabled: wasOpened && !documents,
        onError: (err) => handleRequestError(err),
    });

    useQuery(
        [`documentDownload`, document],
        () => (document != null ? downloadDocument(api, document.id) : null),
        {
            onSuccess: (data) => {
                data && FileSaver.saveAs(new Blob([data]), document?.fileName);
                setDocument(undefined);
            },
            enabled: wasOpened && document != null,
            onError: (err: AxiosError<ArrayBuffer>) => {
                let resp = undefined;
                if (err.response?.data)
                    resp = JSON.parse(
                        String.fromCharCode(...new Uint8Array(err.response?.data))
                    ) as AxiosErrorResponse;
                handleRequestError(resp);
                setDocument(undefined);
            },
            retry: false,
        }
    );
    // const { data } = useQuery([`overdueDaysCount`], () => getOverdueDaysCount(api, id));

    // const documentMutation = useMutation({
    //     mutationFn: (id: number) => DocumentsGenerateTaskAdd(api, id),
    //     onSuccess: () => {
    //         addToast({
    //             type: 'success',
    //             title: t('BackOfficeLoadingSuccessfulMsg'),
    //             description: t('BackOfficeTaskAdded'),
    //         });
    //     },
    //     onError: (e) => handleRequestError(e),
    // });
    //
    // const firstFileDate = documentsCourt?.[0]?.files?.[0]?.createDate;
    // const isCourtDocToday = firstFileDate
    //     ? new Date(firstFileDate).toISOString().split('T')[0] === today
    //     : false;
    //
    // const isCourtButtonDisabled = !data || data < 60 || isLocked || isCourtDocToday;
    //
    // const documentGenerationTaskAdd = () => {
    //     if (!hasRole('orderDocumentsGenerateTaskAdd')) {
    //         addToast({
    //             type: 'danger',
    //             description: t('BackOfficeNotEnoughRights'),
    //         });
    //         return;
    //     }
    //     lock();
    //     documentMutation.mutate(id);
    // };

    return (
        <>
            <Card>
                <CardHeader>
                    <Trans i18nKey={'BackOfficePatternDocs'} />
                </CardHeader>
                <CardBody>
                    {documentsQuery.isFetching ? (
                        <Pending />
                    ) : (
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>
                                        <Trans i18nKey={'BackOfficeName'} />
                                    </th>
                                    <th>
                                        <Trans i18nKey={'BackOfficeFiles'} />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {documentsOther != null ? (
                                    documentsOther.map((doc, idx) => (
                                        <tr key={idx}>
                                            <td>{doc.name}</td>
                                            <td>
                                                {doc.files &&
                                                    doc.files.map((file, idx) => (
                                                        <div key={idx}>
                                                            <Link
                                                                download={file.fileName}
                                                                to={`#documents/${file.id}`}
                                                                onClick={async (e) => {
                                                                    e.preventDefault();
                                                                    setDocument(file);
                                                                }}
                                                            >
                                                                {file.fileName}
                                                            </Link>
                                                        </div>
                                                    ))}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td rowSpan={2}>
                                            <NoData />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    )}
                </CardBody>
            </Card>

            {/*<div className="document-for-court-container">*/}
            {/*    {hasRole('orderGetOverdueDaysCount') && (*/}
            {/*        <Button*/}
            {/*            className="document-for-court-btn"*/}
            {/*            onClick={documentGenerationTaskAdd}*/}
            {/*            disabled={isCourtButtonDisabled}*/}
            {/*        >*/}
            {/*            {t('BackOfficeButtonDocumentForCourt')}*/}
            {/*        </Button>*/}
            {/*    )}*/}
            {/*    {documentsCourt &&*/}
            {/*        documentsCourt.length > 0 &&*/}
            {/*        (isCourtDocToday ? (*/}
            {/*            <Trans i18nKey="BackOfficeDocumentActual" />*/}
            {/*        ) : (*/}
            {/*            <Trans i18nKey="BackOfficeDocumentNotActual" />*/}
            {/*        ))}*/}
            {/*</div>*/}

            {/*<Card style={{ marginTop: '20px' }}>*/}
            {/*    <CardHeader>*/}
            {/*        <Trans i18nKey={'BackOfficeDocumentForCourt'} />*/}
            {/*    </CardHeader>*/}
            {/*    <CardBody>*/}
            {/*        {documentsQuery.isFetching ? (*/}
            {/*            <Pending />*/}
            {/*        ) : (*/}
            {/*            <Table bordered>*/}
            {/*                <thead>*/}
            {/*                    <tr>*/}
            {/*                        <th>*/}
            {/*                            <Trans i18nKey={'BackOfficeName'} />*/}
            {/*                        </th>*/}
            {/*                        <th>*/}
            {/*                            <Trans i18nKey={'BackOfficeFiles'} />*/}
            {/*                        </th>*/}
            {/*                    </tr>*/}
            {/*                </thead>*/}
            {/*                <tbody>*/}
            {/*                    {documentsCourt != null ? (*/}
            {/*                        documentsCourt.map((doc, idx) => (*/}
            {/*                            <tr key={idx}>*/}
            {/*                                <td>{doc.name}</td>*/}
            {/*                                <td>*/}
            {/*                                    {doc.files &&*/}
            {/*                                        doc.files.map((file, idx) => (*/}
            {/*                                            <div key={idx}>*/}
            {/*                                                <Link*/}
            {/*                                                    download={file.fileName}*/}
            {/*                                                    to={`#documents/${file.id}`}*/}
            {/*                                                    onClick={async (e) => {*/}
            {/*                                                        e.preventDefault();*/}
            {/*                                                        setDocument(file);*/}
            {/*                                                    }}*/}
            {/*                                                >*/}
            {/*                                                    {file.fileName}*/}
            {/*                                                </Link>*/}
            {/*                                            </div>*/}
            {/*                                        ))}*/}
            {/*                                </td>*/}
            {/*                            </tr>*/}
            {/*                        ))*/}
            {/*                    ) : (*/}
            {/*                        <tr>*/}
            {/*                            <td rowSpan={2}>*/}
            {/*                                <NoData />*/}
            {/*                            </td>*/}
            {/*                        </tr>*/}
            {/*                    )}*/}
            {/*                </tbody>*/}
            {/*            </Table>*/}
            {/*        )}*/}
            {/*    </CardBody>*/}
            {/*</Card>*/}
        </>
    );
};

export default DocumentsTab;
